module.exports = "<svg width=\"9\" height=\"7\" viewBox=\"0 0 9 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path opacity=\"0.5\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 2.02317L1.22215 0.801025L4.49992 4.0788L7.7777 0.801025L8.99985 2.02317L4.49992 6.5231L0 2.02317Z\" fill=\"#302303\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/stake-expand.svg
// module id = 878
// module chunks = 0